import { SxProps, useTheme } from '@mui/material';

import { useMytaverse } from '@providers/MytaverseProvider';
import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  const {
    submitButton: { backgroundColorHover },
  } = appTheme.avatarPage.assets;

  return {
    root: {
      position: 'relative',
    },
    actions: {
      position: 'absolute',
      display: 'flex',
      gap: 0.5,
      top: 16,
      left: 16,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        top: 8,
        left: 8,
      },
    },
    button: (isActive = false) => ({
      color: colors.white,
      fontSize: 14,
      px: 2,
      py: 1,
      background: isActive ? appTheme.mainColor : '#0C0B0B99',
      backdropFilter: isActive ? 'unset' : 'blur(40px)',
      borderRadius: '99px',
      lineHeight: 1.35,
      textTransform: 'none',

      '&:hover': {
        background: appTheme.mainColor,
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 12,
        px: 0.5,
        py: 0.5,
      },
    }),
    imageBox: {
      '& img': {
        width: '100%',
        height: 'auto',
        display: 'flex',
        borderRadius: 4,
        overflow: 'hidden',
      },
    },
  };
};
